import { render } from "./PageTrendRadar.vue?vue&type=template&id=0fbfa498&scoped=true"
import script from "./PageTrendRadar.vue?vue&type=script&lang=js"
export * from "./PageTrendRadar.vue?vue&type=script&lang=js"

import "./PageTrendRadar.vue?vue&type=style&index=0&id=0fbfa498&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbfa498"]])

export default __exports__